import React from 'react'
import './footer.css'
export default function footer() {
  return (
   <>
    <div className='main-div'>
        <p>Made with ❤️ By seniors</p>
    </div>
   </>
  )
}
